//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('purchPlanning', {
//        templateUrl: 'views/components/views/purchPlanning/purchPlanning.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['stateService', 'utilityService', 'translateService', 'modalService', 'purchPlanningService', 'logisticService', 'ttGridFactory', 'rememberService', function (stateService, utilityService, translateService, modalService, purchPlanningService, logisticService, ttGridFactory, rememberService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;

//            let variableNames = {
//                businessco_no: '',
//                stockplace_id: '',
//                portal_user_keyno_purchaser: '',
//                supplier_no: ''
//            };

//            let translations = {
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                gridReady: false,
//                supplierButtons: [
//                    { id: 'goto', icon: 'fa fa-solid fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('customersmenu', { cust_no: vm.model.setting.supplier_no }) }
//                ],
//                setting: {},
//                selectListBusinessCompanies: [],
//                selectListStockPlaces: [],
//                selectListPortalUsers: [],
//                selectListSuppliers: [],
//                creatingPurchase: false
//            };

//            vm.grid = new ttGridFactory({
//                rememberId: '',
//                kendo: {
//                    height: '100%',
//                    sortable: true,
//                    aggregate: true,
//                    pager: false,
//                    selectable: false,
//                    filterable: false
//                }
//            })
//                .setToolbar({ wrapping: true })
//                .setCustomToolbarButtons([{
//                    name: 'customSave',
//                    text: '',
//                    func: () => saveItems(),
//                    icon: 'save',
//                    cssClass: '',
//                    translate: false
//                }]);
            
//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATION FUNCTION

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATION FUNCTION

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadSetting() {
//                vm.model.setting = (await purchPlanningService.getPurchPlanning())[0];
//            }

//            async function loadCompanies() {
//                vm.model.selectListBusinessCompanies = await logisticService.listCompanies();
//            }

//            async function loadStockPlaces() {
//                if (utilityService.validateParmsValue(vm.model.setting.businessco_no) !== true) return;

//                vm.model.selectListStockPlaces = await logisticService.listStocks({ businessco_no: vm.model.setting.businessco_no });
//            }

//            async function loadPortalUserPurchases() {
//                if (utilityService.validateParmsValue(vm.model.setting.businessco_no) !== true) return;

//                vm.model.selectListPortalUsers = await logisticService.listPortalUserPurchases({
//                    businessco_no: vm.model.setting.businessco_no,
//                    add_all: '1'
//                });

//                if (vm.model.setting.portal_user_keyno_purchaser === undefined || vm.model.setting.portal_user_keyno_purchaser === null) {
//                    vm.model.setting.portal_user_keyno_purchaser = '0';
//                }
//            }

//            async function loadSuppliers() {
//                if (utilityService.validateParmsValue(vm.model.setting.portal_user_keyno_purchaser) !== true) return;
//                if (utilityService.validateParmsValue(vm.model.setting.businessco_no) !== true) return;

//                vm.model.selectListSuppliers = await logisticService.listSuppliers({
//                    portal_user_keyno_purchaser: vm.model.setting.portal_user_keyno_purchaser,
//                    businessco_no: vm.model.setting.businessco_no,
//                    add_all: '1'
//                });

//                if (vm.model.setting.supplier_no === undefined || vm.model.setting.supplier_no === null) {
//                    vm.model.setting.supplier_no = '0';
//                }
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region GRID PROCEDURE FUNCTION CALLS

//            async function loadGrid() {
//                if (utilityService.validateParmsValue(vm.model.setting.view_id) === true) {
//                    vm.grid.dataTask.rememberId = vm.model.setting.view_id;
//                }

//                if (utilityService.validateParmsValue(vm.model.setting.p2_datatask_keyno) === true
//                    && utilityService.validateParmsValue(vm.model.setting.businessco_no) === true
//                    && utilityService.validateParmsValue(vm.model.setting.stockplace_id) === true
//                    && utilityService.validateParmsValue(vm.model.setting.portal_user_keyno_purchaser) === true
//                    && utilityService.validateParmsValue(vm.model.setting.supplier_no) === true) {
//                    vm.grid.dataTask.loadData = {
//                        method: vm.model.setting.p2_datatask_keyno,
//                        parameters: vm.model.setting
//                    };

//                    vm.model.gridReady = true;

//                    if (vm.grid.gridfunc !== null) vm.grid.gridfunc.read();
//                }
//            }

//            // #endregion GRID PROCEDURE FUNCTION CALLS

//            // #region REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

//            function rememberFunc(id) {
//                Object.keys(variableNames).forEach((key) => {
//                    variableNames[key] = 'w_' + stateService.getCurrentName() + '.' + key;
//                });

//                if (utilityService.validateParmsValue(variableNames[id]) !== true) return;

//                let variableValue = null;

//                switch (id) {
//                    case 'businessco_no':
//                    case 'stockplace_id':
//                    case 'portal_user_keyno_purchaser':
//                    case 'supplier_no':
//                        if (utilityService.validateParmsValue(vm.model.setting[id]) !== true) return;

//                        variableValue = vm.model.setting[id];
//                        break;
//                    default:
//                        break;
//                }

//                return rememberService.remember(variableNames[id], variableValue);
//            }

//            // #endregion REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

//            // #region FIELD CHANGE MULTI FUNCTIONS

//            vm.onChanged = async function (value, id) {
//                switch (id) {
//                    case 'businessco_no':
//                        if (utilityService.validateWatchValue(value, vm.model.setting.businessco_no) !== true) return;

//                        vm.model.setting.businessco_no = value;

//                        if (utilityService.validateParmsValue(vm.model.setting.businessco_no) !== true) return;

//                        rememberFunc('businessco_no');
//                        await loadStockPlaces();
//                        await loadPortalUserPurchases();
//                        await loadSuppliers();
//                        break;
//                    case 'stockplace_id':
//                        if (utilityService.validateWatchValue(value, vm.model.setting.stockplace_id) !== true) return;

//                        vm.model.setting.stockplace_id = value;

//                        if (utilityService.validateParmsValue(vm.model.setting.stockplace_id) !== true) return;

//                        rememberFunc('stockplace_id');
//                        await loadGrid();
//                        break;
//                    case 'portal_user_keyno_purchaser':
//                        if (utilityService.validateWatchValue(value, vm.model.setting.portal_user_keyno_purchaser) !== true) return;

//                        vm.model.setting.portal_user_keyno_purchaser = value;

//                        if (utilityService.validateParmsValue(vm.model.setting.portal_user_keyno_purchaser) !== true) return;

//                        rememberFunc('portal_user_keyno_purchaser');
//                        await loadSuppliers();
//                        await loadGrid();
//                        break;
//                    case 'supplier_no':
//                        if (utilityService.validateWatchValue(value, vm.model.setting.supplier_no) !== true) return;

//                        vm.model.setting.supplier_no = value;

//                        if (utilityService.validateParmsValue(vm.model.setting.supplier_no) !== true) return;

//                        rememberFunc('supplier_no');
//                        await loadGrid();
//                        break;
//                    default:
//                        utilityService.setValueToVariable(value);
//                        break;
//                }
//            };

//            // #endregion FIELD CHANGE MULTI FUNCTIONS

//            // #region BUTTON SWITCH PROCEDURE FUNCTION CALL

//            vm.createChanges = function () {
//                vm.model.creatingPurchase = true;

//                saveItems();
//            }

//            function saveItems() {
//                let allData = vm.grid.gridfunc.getAllRows();
//                let currentData = [];

//                allData.forEach((item) => {
//                    if (item?.is_selected && item.is_selected === true) {
//                        currentData.push({
//                            stock_keyno: item.stock_keyno,
//                            supplier_no: item.supplier_no,
//                            purchase_quantity: item.purchase_quantity,
//                            deliverydate_wish: item.deliverydate_wish
//                        });
//                    }
//                });

//                purchPlanningService.createPurchase({
//                    stockplace_id: vm.model.setting.stockplace_id,
//                    stocks: currentData
//                }).then((response) => {
//                    if (response[0].errorcode !== '0') {
//                        modalService.show({
//                            type: 'warning',
//                            title: translations.error,
//                            message: response[0].errormessage,
//                            buttons: [{
//                                label: translations.ok,
//                                cssClass: 'btn-warning',
//                                action: function (dialogItself) {
//                                    dialogItself.close();
//                                    vm.model.creatingPurchase = false;
//                                }
//                            }]
//                        });
//                    } else {
//                        vm.model.creatingPurchase = false;

//                        stateService.go('purchhead', { purch_internal_no: response[0].purch_internal_no });
//                    }
//                });
//            }

//            // #endregion BUTTON SWITCH PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                translate();

//                await loadSetting();
//                loadCompanies();
//                loadStockPlaces();
//                loadPortalUserPurchases();
//                loadSuppliers();
//                loadGrid();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
